import { createContext } from "react";

const simulationContext = createContext([{}, function () {}]);

export default simulationContext;
